import React, { Component } from 'react';
import { Link } from 'react-router-dom'


const InfoAbend = () => {
  const isMobile = window.innerWidth <= 767; // Check if the device is mobile

  return (
    <div id="infoabend">
       <div className="section row text-center">  
       <div className="col col-md-12">
            <div className="same-height-box">
            <div className="row">
                  <div className="col-lg-12 text-center">
                    <h1 className="section-heading">Herzliche Einladung zum Informationsabend Heizung oder Sanitär</h1>                    
                    <h2>Unverbindlich ohne Anmeldung</h2>
                    <hr></hr>
                  </div>
                </div>
                <div className="col-md-6">
                            <p>{isMobile ? (
        <img
          src="https://pailer.com/files/home/infoabend-24012025.jpeg"
          className="w-100 img-fluid-mobile img-responsive center-block"
          alt="Informationsabend Heizung in Remchingen"
        />
      ) : (
        <img
          src="https://pailer.com/files/home/infoabend-24012025.jpeg"
          className="w-100 img-fluid img-responsive center-block"
          alt="Informationsabend Heizung in Remchingen - unverbindlich ohne Anmeldung"
        />
      )}
</p>
                  </div>             
                  <div className="col-md-3">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Herzliche Einladung zum Informationsabende</h4>
                    <p className="">Herzlich willkommen zu unseren offenen und unverbindlichen Informationsabenden zu verschiedenen spannenden Themen! Keine Anmeldung erforderlich.
                      <br></br>
                      <br></br>Erfahren Sie alles Wissenswerte rund um das Thema Heizung bei unserem Infoabend Heizung. Wir beantworten Ihre ganz persönlichen Fragen und informieren Sie über aktuelle Entwicklungen im Gebäudeenergiegesetz (GEG) sowie über geplante Förderungen. Zzg. Informationen zum Einsatz von Photovoltaik und Batteriespeichern.
                      <br></br>
                      <br></br>Außerdem bieten wir Ihnen umfassende Informationen zur Badsanierung bei unserem Informationsabend Badsanierung. Erfahren Sie, wie Sie Ihr Bad altersgerecht, stilvoll und komfortabel gestalten können. 
                      <br></br>
                      <br></br>Wir freuen uns auf Ihren Besuch und darauf, Ihnen wertvolle Einblicke und Antworten auf Ihre Fragen zu geben!</p>                  
                  </div>
                  <div className="col-md-3">
                  <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
                    </span>
                      <h4>KOMMEN SIE VORBEI! Unverbindlich ohne Anmeldung.</h4>
                      <p>
                      - Infoabend Heizung 27. Januar 18:00
                      <br></br>- Infoabend Sanitär 6. Februar 18:00
                      <br></br>- Infoabend Heizung 24. Februar 18:00
                      <br></br>- Infoabend Heizung 26. März 18:00
                      <br></br>- Infoabend Sanitär 31. März 18:00             
                      </p>
                      <p className="">Kurt Pailer GmbH & Co. KG<br></br>
                      Kinzigstraße 4<br></br>
                      75196 Remchingen- Wilferdingen</p>
                      </div>
                  
        </div></div></div>
    </div>
  );
};

const InfoAbend2 = () => {
  const isMobile = window.innerWidth <= 767; // Check if the device is mobile

  return (
    <div id="infoabend">
       <div className="section row text-center">  
       <div className="col col-md-12">
            <div className="same-height-box">
            <div className="row">
                  <div className="col-lg-12 text-center">
                    <h1 className="section-heading">Herzliche Einladung zum Informationsabend Heizung</h1>                    
                    <h1 className="section-heading">22.11.2023 18:00 Uhr</h1>                    
                    <hr />
                  </div>
                </div>                         
                  <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Herzliche Einladung zum Informationsabend Heizung</h4>
                    <p className="">Offener, unverbindlicher Informationsabend zum Thema Heizung. Wir beantworten Ihre ganz persönlichen Fragen rund um das Thema Heizung. Mit aktuellen Infos zum GEG und geplanten Förderungen.</p>                    
                  </div>
                  <div className="col-md-6">
                  <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
                    </span>
                      <h4>KOMMEN SIE VORBEI!</h4>
                      <h4>Mittwoch den 22.11.2023 18:00 Uhr</h4>
                      <p className="">Kurt Pailer GmbH & Co. KG<br></br>
                      Kinzigstraße 4<br></br>
                      75196 Remchingen- Wilferdingen</p>
                      </div>
                  
        </div></div></div>
    </div>
  );
};

const InfoAbend3 = () => {
  const isMobile = window.innerWidth <= 767; // Check if the device is mobile

  return (
    <div id="infoabend">
       <div className="section row text-center">  
       <div className="col col-md-12">
            <div className="same-height-box">
            <div className="row">
                  <div className="col-lg-12 text-center">
                    <h1 className="section-heading">Herzlich Willkommen zu unseren Informationsabenden - Offen und Unverbindlich</h1>                    
                    <hr />
                  </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                    <h2 className="section-heading">Informationsabende Heizung</h2>
                      <p>
                        <img src="https://pailer.com/files/home/infoabend-heizung.jpeg"
                        className="w-100 img-fluid-mobile img-responsive center-block"
                        alt="Informationsabend Heizung in Remchingen"/>
                      </p>
                    </div>
                    <div className="col-md-6">
                    <h2 className="section-heading">Informationsabend Badsanierung</h2>
                      <p>
                        <img src="https://pailer.com/files/home/07-11-BADSANIERUNG.jpeg"
                        className="w-100 img-fluid-mobile img-responsive center-block"
                        alt="Informationsabend Bad Sanierung in Remchingen"/>
                      </p>
                    </div>
                                      
                  </div>
                  <div className="row">               
                    <div className="col-md-6">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-info fa-stack-1x fa-inverse"></i>
                      </span>
                      <h4 className="service-heading">Herzliche Einladung zu unseren Informationsabenden</h4>
                      <p className="">Herzlich willkommen zu unseren offenen und unverbindlichen Informationsabenden zu verschiedenen spannenden Themen! Keine Anmeldung erforderlich.
                      <br></br>
                      <br></br>Erfahren Sie alles Wissenswerte rund um das Thema Heizung bei unserem Infoabend Heizung. Wir beantworten Ihre ganz persönlichen Fragen und informieren Sie über aktuelle Entwicklungen im Gebäudeenergiegesetz (GEG) sowie über geplante Förderungen. Zzg. Informationen zum Einsatz von Photovoltaik und Batteriespeichern.
                      <br></br>
                      <br></br>Außerdem bieten wir Ihnen umfassende Informationen zur Badsanierung bei unserem Informationsabend Badsanierung. Erfahren Sie, wie Sie Ihr Bad altersgerecht, stilvoll und komfortabel gestalten können. 
                      <br></br>
                      <br></br>Wir freuen uns auf Ihren Besuch und darauf, Ihnen wertvolle Einblicke und Antworten auf Ihre Fragen zu geben!</p>                  
                    </div>
                    <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
                      </span>
                        <h4>KOMMEN SIE VORBEI! Unverbindlich ohne Anmeldung.</h4>
                        <b>Informationsabende Heizung</b>
                        <br></br>Donnerstag den 12.09.2024 um 18:00 Uhr
                        <br></br>Montag den 14.10.2024 um 18:00 Uhr
                        <br></br>Freitag den 15.11.2024 um 18:00 Uhr
                        
                        <br></br><br></br>
                        <b>Informationsabend Badsanierung</b>
                        <br></br>Donnerstag den 10.10.2024 um 18:00 Uhr
                        <br></br>Freitag den 22.11.2024 um 18:00 Uhr

                        <br></br><br></br>
                        <b>Adresse:</b>
                        <br></br><p className="">Kurt Pailer GmbH & Co. KG<br></br>
                        Kinzigstraße 4<br></br>
                        75196 Remchingen- Wilferdingen</p>
                        </div>
                  </div>
                  
        </div></div></div>
    </div>
  );
};

export default class Home extends Component {

  componentDidMount() {
    try {
      window.adjustSubmenu();
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (      
      <div className="Home">
        <div className="block row portfolio section bg-light" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <h1>Eingeschränkte Erreichbarkeit</h1>
          <center><h2>Bis 05. Mai 2025 wegen IT-Umstellung</h2>
          <p>Liebe Kundinnen, Liebe Kunden,<br></br>
          wir haben eine interne IT-Umstellung und sind daher bis einschließlich 05.05.2025 telefonisch und per E-Mail nicht erreichbar.
          In dieser Zeit werden unsere E-Mails und Anrufe also nicht bearbeitet und nicht weitergeleitet.
          <br></br>
          In dringenden Fällen wenden Sie sich bitte an unsere Notdienstnummer.
          Diese ist unseren Wartungsvertragskunden bekannt.
          </p></center>
        </div>
        <div id="PORTFOLIO" className="block row portfolio section bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="same-height-box">
              <h1>Heizung | Bad | Sanitär | Photovoltaik</h1>
              <hr className="gray"></hr>
              <div className="row">
                <div className="col-md-3 col-sm-6 portfolio-item">
                  <Link to={`/heizung`} className="portfolio-link" >
                    <div className="portfolio-hover">
                      <div className="portfolio-hover-content">
                        <i className="fa fa-plus fa-3x"></i>
                      </div>
                    </div>
                    <img src="https://pailer.com/files/home/portfolio/heizung.jpg" className="img-responsive" alt="" />
                  </Link>
                  <Link to={`/heizung`} className="portfolio-link" >
                    <div className="same-height portfolio-caption">
                      <h4>Heizung</h4>
                      <p className="text-muted">...
                        <br></br>24H NOTDIENST
                        <br></br>KUNDENDIENST
                        <br></br>WÃRMEBEDARFSRECHNUNG
                        <br></br>HEIZUNGSMODERNISIERUNG
                        <br></br>...</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-3 col-sm-6 portfolio-item">
                  <Link to={`/ihr-bad`} className="portfolio-link" >
                    <div className="portfolio-hover">
                      <div className="portfolio-hover-content">
                        <i className="fa fa-plus fa-3x"></i>
                      </div>
                    </div>
                    <img src="https://pailer.com/files/home/portfolio/ihr-bad.jpg" className="img-responsive" alt="" />
                  </Link>
                  <Link to={`/ihr-bad`} className="portfolio-link" >
                    <div className="same-height portfolio-caption">
                      <h4>Ihr Bad</h4>
                      <p className="text-muted">...
                        <br></br>AUS EINER HAND
                        <br></br>INDIVIDUELLE PLANUNG
                        <br></br>STAUBFREIE SANIERUNG
                        <br></br>..</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-3 col-sm-6 portfolio-item">
                  <Link to={`/sanitaer`} className="portfolio-link" >
                    <div className="portfolio-hover">
                      <div className="portfolio-hover-content">
                        <i className="fa fa-plus fa-3x"></i>
                      </div>
                    </div>
                    <img src="https://pailer.com/files/home/portfolio/sanitaer.jpg" className="img-responsive" alt="" />
                  </Link>
                  <Link to={`/sanitaer`} className="portfolio-link" >
                    <div className="same-height portfolio-caption">
                      <h4>Sanitär</h4>
                      <p className="text-muted">...
                        <br></br>KUNDENDIENST
                        <br></br>INDIVIDUELLE PLANUNG
                        <br></br>GROSSPROJEKTE
                        <br></br>...</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-3 col-sm-6 portfolio-item">
                  <Link to={`/photovoltaik`} className="portfolio-link" >
                    <div className="portfolio-hover">
                      <div className="portfolio-hover-content">
                        <i className="fa fa-plus fa-3x"></i>
                      </div>
                    </div>
                    <img src="https://pailer.com/files/home/portfolio/photovoltaik.jpg" className="img-responsive" alt="" />
                  </Link>
                  <Link to={`/photovoltaik`} className="portfolio-link" >
                    <div className="same-height portfolio-caption">
                      <h4>Photovoltaik</h4>
                      <p className="text-muted">...
                        <br></br>INDIVIDUELLE PLANUNG
                        <br></br>INSTALLATION
                        <br></br>ANMELDUNG
                        <br></br>INBETRIEBNAHME
                        <br></br>...</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="services" className="block row portfolio section" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="services" id="Unser Service">
              <div className="">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <h1 className="section-heading">Services</h1>
                    <hr></hr>
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-md-4">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-mobile fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">24h Notdienst</h4>
                    <p className="text-muted">Wir sind 24h rund um die Uhr im Notfall für unsere Bestandskunden erreichbar.</p>
                  </div>
                  <div className="col-md-4">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Beratung</h4>
                    <p className="text-muted">Sie wünschen eine umfassende Beratung und ein unverbindliches Angebot? Sprechen Sie uns an, wir
                      freuen uns auf Ihre Anfrage.
                      <br></br><a href="mailto:info@pailer.com">info@pailer.com</a> | <a href="tel:+497232372506">07232 / 37 25 06</a>
                      <br></br><br></br>Folgend finden Sie unsere Links zu den Anfrage Formularen (externe Webseite):
                      <br></br>
                      <br></br>
                      <a href="https://form.jotform.com/241891684910363" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular allgemeine Anfrage</button>
                          </a>
                          <p></p>
                          <a href="https://form.jotform.com/241623490861053" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Heizung</button>
                          </a>
                          <p></p>
                          <a href="https://form.jotform.com/241891698027367" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Wartung Heizung</button>
                          </a>
                          <p></p>
                          <a href="https://form.jotform.com/241883854372365" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Badsanierung</button>
                          </a>
                          <p></p>
                          <a href="https://form.jotform.com/241970376927367" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Photovoltaik</button>
                          </a>                      
                      </p>                    
                  </div>
                  <div className="col-md-4">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-wrench fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Kundendienst</h4>
                    <p className="text-muted">Sie sind auf der Suche nach einem kompetenten Partner zur Wartung- und Instandhaltung Ihrer Heizungs-
                      oder Wasseraufbereitungsanlage? Wir bieten Ihnen einen umfassenden Service
                      <br></br><a href="mailto:info@pailer.com">info@pailer.com</a> | <a href="tel:+497232372506">07232 / 37 25 06</a>.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="social" className="block row portfolio section bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="social" id="Social">
              <div className="">
                <div className="row text-center">
                  <div className="col-md-6">
                    <a href="https://www.facebook.com/KurtPailerGmbHCoKG/" target="_blank">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-facebook-official fa-stack-1x text-primary"></i>
                      </span>
                    </a>
                    <p className="text-muted">Firma Pailer auf <a href="https://www.facebook.com/KurtPailerGmbHCoKG/" target="_blank">Facebook (externe Webseite)</a> - hier erhältst du Einblicke hinter die Kulissen.</p>
                  </div>
                  <div className="col-md-6">
                    <a href="https://www.instagram.com/fa.kurtpailer/" target="_blank">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-instagram fa-stack-1x text-primary"></i>
                      </span>
                    </a>
                    <p className="text-muted">Firma Pailer auf <a href="https://www.instagram.com/fa.kurtpailer/" target="_blank">Instagram (externe Webseite)</a> - Bilder sagen mehr als tausend Worte.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="servicezeiten" className="block row portfolio section" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="services" id="Telefonische Erreichbarkeit">
              <div className="">
                <div className="row text-center">
                  <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-mobile fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Telefonzeiten</h4>
                    <p className="text-muted">Wir haben unsere Telefonzeiten angepasst.
                      <br></br><br></br>
                      Sie erreichen uns täglich: 08:00-13:00 Uhr und zusätzlich donnerstags 14:00-16:00 Uhr.
                      <br></br><br></br>
                      Gerne können Sie uns außerhalb dieser Zeiten eine e-mail schreiben, wir rufen Sie zurück. Selbstverständlich sind wir für unsere Bestandskunden in Notfällen auch außerhalb unserer Bürozeiten über unsere Notdienstnummer erreichbar.
                      <br></br><br></br>
                      info@pailer.com | 07232 / 37 25 06
                      <br></br><br></br>
                      Vielen Dank für Ihr Vertrauen
                      <br></br>
                      Ihr Team der Firma Kurt Pailer GmbH & Co. KG
                    </p>
                  </div>
                  <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-wrench fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Notdienst</h4>
                    <p className="text-muted">Sie haben am Wochenende oder am Feiertag eine akute Heizungsstörung, kein Warmwasser und Ihre Räume sind kalt?
                      <br></br><br></br>
                      Sie haben einen Wasserrohrbruch?<br></br>
                      Für unsere Bestandskunden rücken unsere Techniker auch außerhalb der üblichen Arbeitszeiten, am Wochenende oder an Feiertagen aus.
                      <br></br><br></br>
                      Der Feierabend und auch die Wochenenden sind für unsere Techniker als Erholungsphasen sehr wichtig.
                      <br></br><br></br>
                      Bitte prüfen Sie daher im Vorfeld, ob es sich um einen tatsächlichen Notfall handelt oder ob es bis zum nächsten Tag warten kann.
                      <br></br><br></br>
                      Vielen Dank für Ihr Vertrauen
                      <br></br>
                      Ihr Team der Firma Kurt Pailer GmbH & Co. KG</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="block-4" className="block row section bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="section section">
              <div className="services">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <h1 className="section-heading">Wir sind Vaillant Kompetenzpartner!</h1>
                    <hr />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <img src="https://pailer.com/files/heizung/vaillant/vaillant_kompetenz_partner_logo.JPG" className="img-responsive" alt="Firma Kurt Pailer ist Vailant Kompetenzpartner"
                    />
                  </div>
                  <div className="col-md-3">
                    Während der vergangenen Jahre haben wir unter Beweis gestellt, dass wir zu den besten Vaillant Partnern deutschlandweit gehören.
                    Wir freuen uns daher sehr, dass Vaillant uns erneut für weitere zwei Jahre zum Kompetenzpartner
                    ausgezeichnet hat.
                    <br></br>
                    <br></br>
                    Mit uns an Ihrer Seite sind Sie als Kunde also bestens beraten. Sie können sich auf unser Fachwissen verlassen! Ob Badsanierung,
                    Heizungsmodernisierung oder Neubau, wir beraten Sie gerne!
                    <br></br>
                    <br></br>
                  </div>
                  <div className="col-md-3">
                    Vaillant Kompetenzpartner stehen für ...
                    <br></br>
                    <br></br>
                    <ul>
                      <li>Kundenorientierten Service</li>
                      <li>Kompetente Leistung</li>
                      <li>Große Innovationskraft</li>
                      <li>Gleichbleibend</li>
                      <li>hohe Qualität</li>
                      <li>Nachhaltigkeit</li>
                      <li>5Plus Sorglos Versprechen</li>
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <img src="https://pailer.com/files/heizung/vaillant/kompetenz_partner.JPG" className="img-responsive" alt="Firma Kurt Pailer ist Vaillant Kompetenzpartner"
                    />
                    <p className="text-muted"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/home/Home.js